import { render, staticRenderFns } from "./coffee-espresso-list-home.vue?vue&type=template&id=2122a32d&scoped=true&"
import script from "./coffee-espresso-list-home.vue?vue&type=script&lang=js&"
export * from "./coffee-espresso-list-home.vue?vue&type=script&lang=js&"
import style0 from "./coffee-espresso-list-home.vue?vue&type=style&index=0&id=2122a32d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2122a32d",
  null
  
)

export default component.exports